import { NotificationGroup, UserInfoModel, UserNotifGroups, UserPreferences } from "../../reducers/states/user-info";
import { types } from "../types";

export const loadUserInfoAndPreferences = () => ({
  type: types.GET_CURRENT_USER_INFO_AND_PREFERENCES,  
});

// Get Current User Info
export const getCurrentUserInfoRequest = () => ({
  type: types.GET_CURRENT_USER_INFO,
  payload: { },
});
export const getCurrentUserInfoSuccess = (userInfo: UserInfoModel) => ({
  type: types.GET_CURRENT_USER_INFO_SUCCESS,
  payload: { userInfo },
});
export const getCurrentUserInfoFailure = (failureMessage: string) => ({
  type: types.GET_CURRENT_USER_INFO_FAILURE,
  payload: { failureMessage },
});

// Get User Info Request - for displaying names in the app
export interface getUserInfoPayload {
  email: string;
}
export const getUserInfoRequest = (email: string) => ({
  type: types.GET_USER_INFO,
  payload: { email } as getUserInfoPayload,
});
export const getUserInfoSuccess = (userInfo: UserInfoModel) => ({
  type: types.GET_USER_INFO_SUCCESS,
  payload: { userInfo },
});
export const getUserInfoFailure = (failureMessage: string) => ({
  type: types.GET_USER_INFO_FAILURE,
  payload: { failureMessage },
});

// Get all ReadyOp Notification Groups
export const getAllReadyOpGroupsRequest = () => ({
  type: types.GET_ALL_READYOP_GROUPS,
  payload: {},
});
export const getAllReadyOpGroupsSuccess = (notifGroups: NotificationGroup[]) => ({
  type: types.GET_ALL_READYOP_GROUPS_SUCCESS,
  payload: { notifGroups },
});
export const getAllReadyOpGroupsFailure = (failureMessage: string) => ({
  type: types.GET_ALL_READYOP_GROUPS_FAILURE,
  payload: { failureMessage },
});

export interface getUserReadyOpGroupsPayload {
  email: string;
}

// Get a User's ReadyOp Notification Groups
export const getUserReadyOpGroupsRequest = (email: string) => ({
  type: types.GET_USER_READYOP_GROUPS,
  payload: { email } as getUserReadyOpGroupsPayload,
});
export const getUserReadyOpGroupsSuccess = (userNotifGroups: UserNotifGroups[]) => ({
  type: types.GET_USER_READYOP_GROUPS_SUCCESS,
  payload: { userNotifGroups },
});
export const getUserReadyOpGroupsFailure = (failureMessage: string) => ({
  type: types.GET_USER_READYOP_GROUPS_FAILURE,
  payload: { failureMessage },
});

// Update User's Notifications groups in ReadyOp
export interface updateUserReadyOpGroupsPayload {
  groupIds: string[];
  email: string;
  isTextable: boolean;
}
export const updateUserReadyOpGroupsRequest = (groupIds: string[], email: string, isTextable: boolean) => ({
  type: types.UPDATE_USER_READYOP_GROUPS,
  payload: { groupIds, email, isTextable } as updateUserReadyOpGroupsPayload,
});
export const updateUserReadyOpGroupsSuccess = (successMessage: string) => ({
  type: types.UPDATE_USER_READYOP_GROUPS_SUCCESS,
  payload: { successMessage },
});
export const updateUserReadyOpGroupsFailure = (failureMessage: string) => ({
  type: types.UPDATE_USER_READYOP_GROUPS_FAILURE,
  payload: { failureMessage },
});

// Get User Preferences
export const getUserPreferencesRequest = () => ({
  type: types.GET_USER_PREFERENCES,
  payload: {},
});
export const getUserPreferencesSuccess = (userPreferences: UserPreferences) => ({
  type: types.GET_USER_PREFERENCES_SUCCESS,
  payload: { userPreferences },
});
export const getUserPreferencesFailure = (failureMessage: string) => ({
  type: types.GET_USER_PREFERENCES_FAILURE,
  payload: { failureMessage },
});

// Update User Preferences
export interface updateUserPreferencesPayload {
  userPreferences: UserPreferences;
  userEmail?: string
}
export const updateUserPreferencesRequest = (
  userPreferences: UserPreferences,
  userEmail?: string,
) => ({
  type: types.UPDATE_USER_PREFERENCES,
  payload: {
    userPreferences,
    ...(userEmail && { userEmail }),
  } as updateUserPreferencesPayload,
});
export const updateUserPreferencesSuccess = (successMessage : string) => ({
  type: types.UPDATE_USER_PREFERENCES_SUCCESS,
  payload: { successMessage },
});
export const updateUserPreferencesFailure = (failureMessage : string) => ({
  type: types.UPDATE_USER_PREFERENCES_FAILURE,
  payload: { failureMessage  },
});
